import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Row, Col } from "react-bootstrap";
import Helmet from "react-helmet";

class UnderMaintenance extends Component {

  render() {
    const { intl } = this.props;

    return (
      <>
        <Helmet>
        under_maintenance
          <title> {intl.formatMessage({ id: "enrich.generic_page.under_maintenance", defaultMessage: "Under Maintenance: Enrich B2B" })} </title>
        </Helmet>

        <Row className="text-center mt-10">
          <Col className="text-uppercase" sm={12}>
            <h2 className="title--bold">
              <FormattedMessage id="generic_page.under_maintenance.title" defaultMessage="Under Maintenance" />
            </h2>
          </Col>
          <Col sm={12}>
            <h3><FormattedMessage id="generic_page.under_maintenance.sub_title" defaultMessage="This page you're looking for is currently under maintenance and will be back soon." /></h3>
          </Col>
        </Row>
      </>
    );
  }
}

export default injectIntl(UnderMaintenance);